export const sellOrderHeaderElements = [
  { label: "Fecha", value: "fechaCreacion", align: "inherit" },
  { label: "Titular cuenta", value: "titular", align: "inherit" },
  { label: "Precio", value: "monto", align: "inherit" },
  { label: "Precio final", value: "precioFinal", align: "inherit" },
  { label: "Tipo", value: "tipoFijacion", align: "inherit" },
  { label: "Grano", value: "grano", align: "inherit" },
  { label: "Toneladas", value: "toneladas", align: "inherit" },
  { label: "Estado", value: "displayEstado", align: "inherit"}
];
